import styled from "@mui/material/styles/styled";
import { Box } from "@mui/material";

export const MainLayoutContainer = styled(Box)(({ theme }) => ({
  minHeight: "100vh",
  display: "flex",
  flexDirection: "column",
  backgroundColor: theme.palette.background.default,
}));

export const MainSidebarArea = styled(Box)(({ theme }) => ({
  width: "280px",
  minHeight: "calc100vh - 64px)",
  backgroundColor: theme.palette.background.paper,
  borderRight: `1px solid ${theme.palette.divider}`,
  position: "sticky",
  top: "64px",
}));

export const MainContentArea = styled(Box)(({ theme }) => ({
  flex: 1,
  padding: theme.spacing(3),
  backgroundColor: theme.palette.background.default,
  minHeight: "calc(100vh - 64px)",
  height: "100vh",
  overflow: "auto",
}));
